import React, { useState } from "react";
import { Button } from "react-bootstrap";

// Single source of truth for the public influencer link shape. A visitor who
// opens this is 302-redirected (via public/.htaccess in production) straight to
// the Supabase Edge Function, which logs the click and forwards to the App Store
// or Google Play. Uses window.location.origin so it resolves correctly in dev
// (localhost) and prod (joinsarv.com) alike.
export const buildReferralLink = (promoCode) =>
  `${window.location.origin}/r/${encodeURIComponent(promoCode)}`;

// Displays the shareable referral link with a one-click Copy button.
const ReferralLink = ({ promoCode, size = "sm" }) => {
  const [copied, setCopied] = useState(false);

  if (!promoCode) return null;
  const link = buildReferralLink(promoCode);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (e) {
      console.error("Clipboard copy failed:", e);
    }
  };

  return (
    <div className="d-flex align-items-center gap-2 flex-wrap">
      <code
        style={{
          fontSize: "13px",
          background: "#f5f8f4",
          color: "darkgreen",
          padding: "6px 10px",
          borderRadius: "6px",
          wordBreak: "break-all",
        }}
      >
        {link}
      </code>
      <Button size={size} variant="outline-success" onClick={handleCopy}>
        {copied ? "Copied!" : "Copy"}
      </Button>
    </div>
  );
};

export default ReferralLink;
